import {ConnectedRouter} from 'connected-react-router'
import AppLayout from "./AppLayout";
import AppRoutes from "../components/AppRoutes";
import Footer from "../components/AboutPage/Footer/Footer";

function Main({ history }) {
    return (
        <ConnectedRouter history={history}>
            <AppLayout>
                <AppRoutes />
                <Footer />
            </AppLayout>
        </ConnectedRouter>
    );
}

export default Main;
